"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _project = require("@/api/project/project");
var _validate = require("@/libs/validate1.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      typeList: [],
      addForm: {
        formList: [{
          scoringName: "",
          scoringScore: "",
          scoringSort: "",
          scoringContent: "",
          scoringElement: "",
          id: "",
          groupId: this.$route.query.groupId,
          matchId: this.$route.query.matchId,
          stageId: this.$route.query.stageId
        }]
      },
      formRole: {
        scoringName: [{
          required: true,
          message: "请填写评分项名称",
          trigger: "blur"
        }],
        scoringScore: [{
          required: true,
          message: "请分配评分项分数",
          trigger: "blur"
        }, {
          validator: _validate.isInteger,
          trigger: "blur"
        }],
        scoringSort: [{
          required: true,
          message: "请输入评分项所在排序",
          trigger: "blur"
        }, {
          validator: _validate.isMore0,
          trigger: "blur"
        }]
        // requirements: [
        //   { required: true, message: "请选择作品文件上传要求", trigger: "blur" }
        // ]
      }
    };
  },
  methods: {
    // 提交
    submit: function submit(v) {
      var _this = this;
      this.$refs[v].validate(function (valid) {
        if (valid) {
          var sc = 0;
          _this.addForm.formList.forEach(function (item) {
            sc = sc + +item.scoringScore;
          });
          if (sc != 100) {
            return _this.$message.error("所有评分项相加总分应为100分");
          } else {
            (0, _project.scoreSave)({
              groupId: _this.$route.query.groupId,
              matchId: _this.$route.query.matchId,
              stageId: _this.$route.query.stageId,
              matchScoreItemRuleParamList: _this.addForm.formList
            }).then(function (res) {
              if (res.code === 2000) {
                _this.$message.success("操作成功。");
                history.go(-1);
              }
            });
          }
        } else {
          _this.$message.error("请先核对填写内容。");
        }
      });
    },
    // 获取评分项列表
    getScoreList: function getScoreList() {
      var _this2 = this;
      (0, _project.scoreSet)({
        stageId: this.$route.query.stageId,
        groupId: this.$route.query.groupId,
        matchId: this.$route.query.matchId
      }).then(function (res) {
        var data = res.data;
        // 保证页面存在一个评分项设置
        if (data.length > 0) {
          _this2.addForm.formList = res.data;
        }
      });
    },
    // 新增评分项
    addItem: function addItem() {
      this.addForm.formList.push({
        scoringName: "",
        scoringScore: "",
        scoringSort: "0",
        scoringContent: "",
        scoringElement: "",
        id: "",
        groupId: this.$route.query.groupId,
        matchId: this.$route.query.matchId,
        stageId: this.$route.query.stageId
      });
    },
    // 删除评分项
    removeItem: function removeItem(e) {
      console.log(e);
      this.addForm.formList.splice(e, 1);
    },
    // 返回
    isBack: function isBack() {
      history.back(-1);
    }
  },
  created: function created() {
    this.getScoreList();
  }
};